import React from 'react'

function Erorr_404() {
  return (
    <div>Erorr_404</div>
  )
}

export default Erorr_404